import { useMutation } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axios/editorInstance'
import extract from '@pepper/utils/src/function/extract'
import {
  ContentAuditReport,
  ContentAuditReportType,
} from '@pepper/utils/src/types/content_audit'
import { postContentAuditStatus } from '@pepper/utils/src/api/assignments/assignments'

type CreatorsParameter = {
  itemId: string
  platform: 'creators'
  payload: Record<string, boolean>
  docId?: never
  body?: never
  async?: boolean
}

type OtherPlatformParameter = {
  docId: string
  platform: Exclude<Platforms, 'creators'>
  body: {
    app: 'audit'
    reports: ContentAuditReportType[]
  }
  itemId?: never
  payload?: never
  async?: boolean
}

type Parameter = CreatorsParameter | OtherPlatformParameter

async function createAudit({
  body,
  docId,
  itemId,
  platform,
  payload,
  async = true,
}: Parameter) {
  const url = `/v2/documents/${docId}/apps/reports?async=${async}`

  try {
    // different api based on platform
    if (platform === 'creators') {
      const _response = await postContentAuditStatus(true, itemId, payload)
      if (_response.status === 'error') throw new Error(_response.error)
      return _response.data as ContentAuditReport
    }

    const response = await axios.post(url, body)
    return extract.data<ContentAuditReport>(response).data
  } catch (error) {
    throw new Error(extract.error(error).error)
  }
}

export function useCreateAudit() {
  return useMutation({
    mutationKey: ['content-audit'],
    mutationFn: createAudit,
  })
}
